import { useCallback, useState } from "react";
import { debounce } from "lodash";
import { Column } from "../../system-design/Table/DSBaseTable/components/DSBaseTable";
import useCollectionCodesInfiniteQuery from "./useCollectionCodesInfiniteQuery";
import { CollectionCode } from "../../../api/collection";

const useCollectionCodesList = (
  limit: number = 40,
  filter?: Record<string, unknown>,
) => {
  const [textSearch, setTextSearch] = useState<string>("");

  const { data, fetchNextPage, ...rest } = useCollectionCodesInfiniteQuery(
    textSearch,
    limit,
    undefined,
    filter,
  );

  const handleTextSearch = useCallback(
    debounce((text: string) => setTextSearch(text), 500),
    [],
  );

  const columns: Column<CollectionCode>[] = [
    { field: "orderName", label: "Order Name" },
    { field: "collectionName", label: "Collection Name" },
    { field: "collectionId", label: "Collection ID" },
    { field: "createdAt", label: "Created Date" },
    { field: "code", label: "Code" },
    { field: "clockId", label: "Clock ID" },
    { field: "multiUse", label: "Multi-Use" },
    { field: "expiresAt", label: "Expires" },
  ];

  return {
    data,
    fetchNextPage,
    ...rest,
    handleTextSearch,
    columns,
  };
};

export default useCollectionCodesList;
